"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateView = exports.ListCreateView = exports.ViewSet = void 0;
const mixins_1 = require("./mixins");
// ------------------------------
// VIEWSET
// ------------------------------
class ViewSet {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.list = this._list;
        this.create = this._create;
        this.update = this._update;
        this.axiosInstance = axiosInstance;
    }
}
exports.ViewSet = ViewSet;
(0, mixins_1.applyMixins)(ViewSet, [mixins_1.ListMixin, mixins_1.CreateMixin, mixins_1.UpdateMixin]);
// ------------------------------
// LIST CREATE VIEW
// ------------------------------
class ListCreateView {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.list = this._list;
        this.create = this._create;
        this.axiosInstance = axiosInstance;
    }
}
exports.ListCreateView = ListCreateView;
(0, mixins_1.applyMixins)(ListCreateView, [mixins_1.ListMixin, mixins_1.CreateMixin]);
// ------------------------------
// CREATE VIEW
// ------------------------------
class CreateView {
    constructor(axiosInstance) {
        this.endpoint = "";
        this.create = this._create;
        this.axiosInstance = axiosInstance;
    }
}
exports.CreateView = CreateView;
(0, mixins_1.applyMixins)(CreateView, [mixins_1.CreateMixin]);
// ------------------------------
// VIEWSET
// ------------------------------
//# sourceMappingURL=views.js.map